export enum ReportSectionType {
	HeaderLeft = 1,
	HeaderCenter = 2,
	HeaderRight = 3,
	FooterLeft = 4,
	FooterCenter = 5,
	FooterRight = 6
}